export default "Ballerup Gokart- & Eventcenter opened i 2006. They opened their first escape room in June 2021.";